import ReactGA from "react-ga4";

export function GAEvent(category, action, label) {
  ReactGA.event({
    category: category,
    action: action,
    label: label
  });
}
